import type { FormattingContextState } from './types';
import { ReactNode, createContext, useContext } from 'react';
import { noop } from 'lodash';
import { ARDOQ_DEFAULT_LOCALE } from '@ardoq/locale';
import { DEFAULT_ARDOQ_I18NLOCALE } from '@ardoq/i18n';

const suggestionLoaderPlaceholder = async () => [];
const labelLoaderPlaceholder = async () => undefined;

const FormattingContext = createContext<FormattingContextState>({
  rules: [],
  removeRule: noop,
  updateRule: noop,
  reorderRules: noop,
  asyncLabelLoaders: {
    getComponentLabelAsync: labelLoaderPlaceholder,
    getWorkspaceLabelAsync: labelLoaderPlaceholder,
    getUserLabelAsync: labelLoaderPlaceholder,
    getReferenceLabelAsync: labelLoaderPlaceholder,
    getComponentKeyLabelAsync: labelLoaderPlaceholder,
  },
  asyncSuggestionsLoaders: {
    loadReferenceOIDSuggestionsAsync: suggestionLoaderPlaceholder,
    loadComponentKeySuggestionsAsync: suggestionLoaderPlaceholder,
    loadParentComponentSuggestionsAsync: suggestionLoaderPlaceholder,
    loadComponentSuggestionsIncludingCurrentComponentAsync:
      suggestionLoaderPlaceholder,
    loadComponentSuggestionsAsync: suggestionLoaderPlaceholder,
    loadWorkspaceSuggestionsAsync: suggestionLoaderPlaceholder,
    loadUserSuggestionsAsync: suggestionLoaderPlaceholder,
    loadTagSuggestionsAsync: suggestionLoaderPlaceholder,
    loadComponentTypeNameSuggestionsAsync: suggestionLoaderPlaceholder,
    loadReferenceTypeNameSuggestionsAsync: suggestionLoaderPlaceholder,
  },
  tagsFormattingGroups: [],
  addRuleButtonOptions: [],
  ruleInfo: {},
  componentTypeNames: [],
  referenceTypeNames: [],
  locale: ARDOQ_DEFAULT_LOCALE,
  i18nLocale: DEFAULT_ARDOQ_I18NLOCALE,
});
type FormattingContextProviderProperties = {
  children: ReactNode;
  contextState: FormattingContextState;
};
export const FormattingContextProvider = ({
  children,
  contextState,
}: FormattingContextProviderProperties) => (
  <FormattingContext.Provider value={contextState}>
    {children}
  </FormattingContext.Provider>
);

export const useFormattingContext = () => useContext(FormattingContext);
